import React from "react";
import { Instagram, Mail, Phone, MapPin } from "lucide-react";
import { useLang } from "@/context/LanguageContext";
import { CONTACT } from "@/data/content";
import { scrollToSection } from "@/hooks/useLenis";

export const Footer = () => {
  const { t } = useLang();
  const year = new Date().getFullYear();
  return (
    <footer data-testid="footer" className="bg-[#0A1128] text-[#FAF9F6]">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16 grid grid-cols-1 md:grid-cols-3 gap-12">
        <div>
          <button onClick={() => scrollToSection("hero")} className="font-display text-2xl tracking-[0.18em] uppercase">
            Olivier Boës
          </button>
          <p className="text-[#FAF9F6]/55 text-sm font-light mt-4 max-w-xs leading-relaxed">{t.footer.tagline}</p>
        </div>

        <div className="space-y-4 text-sm">
          <a href={`mailto:${CONTACT.email}`} data-testid="footer-email" className="flex items-center gap-3 text-[#FAF9F6]/75 hover:text-[#C5A880] transition-colors">
            <Mail size={16} /> {CONTACT.email}
          </a>
          <a href={`tel:${CONTACT.phone.replace(/\s/g, "")}`} data-testid="footer-phone" className="flex items-center gap-3 text-[#FAF9F6]/75 hover:text-[#C5A880] transition-colors">
            <Phone size={16} /> {CONTACT.phone}
          </a>
          <p className="flex items-center gap-3 text-[#FAF9F6]/75">
            <MapPin size={16} /> {CONTACT.location}
          </p>
        </div>

        <div className="md:text-right">
          <a
            href={CONTACT.instagram}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-instagram"
            className="inline-flex items-center gap-2 text-sm tracking-[0.15em] uppercase text-[#FAF9F6]/75 hover:text-[#C5A880] transition-colors"
          >
            <Instagram size={16} /> {CONTACT.instagramHandle}
          </a>
        </div>
      </div>
      <div className="border-t border-[#FAF9F6]/10">
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-6 text-[11px] tracking-[0.15em] uppercase text-[#FAF9F6]/40 text-center">
          © {year} Olivier Boës. {t.footer.rights}
        </div>
      </div>
    </footer>
  );
};
